import api from "./api";

export const serialize = (obj) => {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const serializeArray = (obj) => {
  let str = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      if (Array.isArray(obj[p])) {
        for (let o in obj[p]) {
          str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(obj[p][o]));
        }
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
  }
  return str.join("&");
}

export const removeEmptyFilterValues = (data) => {
  const filteredData = {};
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        if (value.length > 0) {
          filteredData[key] = value;
        }
      } else if (value !== '' && value !== null && value !== undefined) {
        filteredData[key] = value;
      }
    }
  }
  return filteredData;
}

export const getUser = () => {
  return Promise.resolve(api.get("/admin/user/me", {}));
};

export const getUserById = (id) => {
  return Promise.resolve(api.get("/admin/user/" + id));
};

export const getUsuariosMapaDaProva = (data) => {
  return Promise.resolve(api.get("/admin/user?" + serialize(data)));
};

export const getFacebookDeletions = (data) => {
  return Promise.resolve(api.get("facebook/deletions?" + serialize(data)));
};

export const processFacebookDeletion = (confirmationCode) => {
  return Promise.resolve(api.post(`facebook/process-deletion/${confirmationCode}`));
};

export const getTokenUsuarioMapaDaProva = (id) => {
  return Promise.resolve(api.get("/admin/user/get-token/" + id));
};

export const getBancas = (data) => {
  return Promise.resolve(api.get("/admin/examining-board?" + serialize(data)));
};

export const storeBanca = (data, progress) => {
  return Promise.resolve(api.post("/admin/examining-board", data, progress));
};

export const getBanca = (id) => {
  return Promise.resolve(api.get("/admin/examining-board/" + id));
};

export const excluirBanca = (id) => {
  return Promise.resolve(api.delete("/admin/examining-board/" + id));
};

export const getInstituicoes = (data) => {
  return Promise.resolve(api.get("/admin/institution?" + serialize(data)));
};

export const storeInstituicao = (data, progress) => {
  return Promise.resolve(api.post("/admin/institution", data, progress));
};

export const getInstituicao = (id) => {
  return Promise.resolve(api.get("/admin/institution/" + id));
};

export const excluirInstituicao = (id) => {
  return Promise.resolve(api.delete("/admin/institution/" + id));
};

export const getFormacoes = (data) => {
  return Promise.resolve(api.get("/admin/formation-area?" + serialize(data)));
};

export const storeFormacao = (data, progress) => {
  return Promise.resolve(api.post("/admin/formation-area", data, progress));
};

export const getFormacao = (id) => {
  return Promise.resolve(api.get("/admin/formation-area/" + id));
};

export const excluirFormacao = (id) => {
  return Promise.resolve(api.delete("/admin/formation-area/" + id));
};

export const getCargos = (data) => {
  return Promise.resolve(api.get("/admin/occupations?" + serialize(data)));
};

export const storeCargo = (data, progress) => {
  return Promise.resolve(api.post("/admin/occupations", data, progress));
};

export const getCargo = (id) => {
  return Promise.resolve(api.get("/admin/occupations/" + id));
};

export const getCargoByConcurso = (id) => {
  return Promise.resolve(api.get("/admin/exam/occupations-by-public-tender/" + id));
};

export const excluirCargo = (id) => {
  return Promise.resolve(api.delete("/admin/occupations/" + id));
};

export const getCarreiras = (data) => {
  return Promise.resolve(api.get("/admin/career?" + serialize(data)));
};

export const storeCarreira = (data, progress) => {
  return Promise.resolve(api.post("/admin/career", data, progress));
};

export const getCarreira = (id) => {
  return Promise.resolve(api.get("/admin/career/" + id));
};

export const excluirCarreira = (id) => {
  return Promise.resolve(api.delete("/admin/career/" + id));
};

export const getOccupationAreas = (data) => {
  return Promise.resolve(api.get("/admin/occupation-area?" + serialize(data)));
};

export const storeOccupationArea = (data, progress) => {
  return Promise.resolve(api.post("/admin/occupation-area", data, progress));
};

export const getOccupationArea = (id) => {
  return Promise.resolve(api.get("/admin/occupation-area/" + id));
};

export const excluirOccupationArea = (id) => {
  return Promise.resolve(api.delete("/admin/occupation-area/" + id));
};

export const getConcursos = (data) => {
  return Promise.resolve(api.get("/admin/public-tender?" + serialize(data)));
};

export const storeConcurso = (data, progress) => {
  return Promise.resolve(api.post("/admin/public-tender", data, progress));
};

export const getConcurso = (id) => {
  return Promise.resolve(api.get("/admin/public-tender/" + id));
};

export const excluirConcurso = (id) => {
  return Promise.resolve(api.delete("/admin/public-tender/" + id));
};

export const getFiltroProvas = (data) => {
  return Promise.resolve(api.get("/admin/prova/buscar?" + serialize(data)));
};

export const getFiltroInstituicoes = (data) => {
  return Promise.resolve(api.get("/admin/instituicoes/buscar?" + serialize(data)));
};

export const getAnosProva = (data) => {
  return Promise.resolve(api.get("/admin/prova-anos?" + serialize(data)));
};

export const getAssuntosPai = (data) => {
  return Promise.resolve(api.get("/admin/prova-materias?" + serialize(data)));
};

export const getQuestoesProva = (id) => {
  return Promise.resolve(api.get("/admin/exam/questions/" + id));
};

export const storeAtribuirQuestoesProvas = (data) => {
  return Promise.resolve(api.post("/admin/question/assign-matter", data));
};

export const updateStatusProva = (id, status) => {
  return Promise.resolve(api.post("/admin/prova/update-status/" + id, status));
};

export const filtroProvas = (data) => {
  const filteredData = removeEmptyFilterValues(data);
  return Promise.resolve(api.get("/admin/exam?" + serializeArray(filteredData)));
};

/**
 * Busca exam(s) no Mapa por banca, órgão, cargo, ano e opcionalmente área de cargo.
 * Usado na importação de questões para verificar se já existe prova com esses atributos.
 * @param {{ banca_id?: number|string, instituicao_id?: number|string, cargo_id?: number|string, ano?: number|string, area_cargo_nome?: string }} params
 * @returns {Promise<{ data: { provas: array, total: number, current_page: number, last_page: number } }>}
 */
export const buscarExamPorAtributos = (params) => {
  const filter = {
    page: 1,
  };
  if (params.banca_id != null && params.banca_id !== '') {
    filter.banca = [String(params.banca_id)];
  }
  if (params.instituicao_id != null && params.instituicao_id !== '') {
    filter.instituicao = [String(params.instituicao_id)];
  }
  if (params.cargo_id != null && params.cargo_id !== '') {
    filter.cargo = [String(params.cargo_id)];
  }
  if (params.ano != null && params.ano !== '') {
    filter.ano = [String(params.ano)];
  }
  const nomeArea = typeof params.area_cargo_nome === 'string' ? params.area_cargo_nome.trim() : '';
  if (nomeArea !== '') {
    filter.area_cargo_nome = [nomeArea];
  }
  const filteredData = removeEmptyFilterValues(filter);
  return Promise.resolve(api.get("/admin/exam?" + serializeArray(filteredData)));
};

export const uploadImagemProvas = (data) => {
  return Promise.resolve(api.post("/admin/exam/upload-image", data));
};

export const uploadImagemComentarios = (data) => {
  return Promise.resolve(api.post("/admin/batch/upload-image", data));
};

export const storeProva = (data, progress) => {
  return Promise.resolve(api.post("/admin/exam", data, progress));
};

export const postBackupEstruturacaoProva = (data) => {
  return Promise.resolve(api.post("/admin/exam/backup", data));
};

export const postHarnessEstruturar = (examId, payload = {}) => {
  return Promise.resolve(api.post(`/admin/exam/harness/estruturar/${examId}`, payload));
};

export const postHarnessRetryMissing = (examId, payload = {}) => {
  return Promise.resolve(api.post(`/admin/exam/harness/retry-missing/${examId}`, payload));
};

export const getHarnessRunLatest = (examId) => {
  return Promise.resolve(api.get(`/admin/exam/harness/runs/latest/${examId}`));
};

export const getHarnessRunEvents = (examId, runId, afterId = 0) => {
  return Promise.resolve(api.get(`/admin/exam/harness/runs/${examId}/${runId}/events?after_id=${afterId}`));
};

export const postHarnessGabaritar = (examId, payload = {}) => {
  return Promise.resolve(api.post(`/admin/exam/harness/gabaritar/${examId}`, payload));
};

export const postHarnessGabaritarRetryMissing = (examId, payload = {}) => {
  return Promise.resolve(api.post(`/admin/exam/harness/gabaritar/retry-missing/${examId}`, payload));
};

export const getHarnessGabaritarLatest = (examId) => {
  return Promise.resolve(api.get(`/admin/exam/harness/gabaritar/runs/latest/${examId}`));
};

export const postHarnessValidarImportacao = (examId, payload = {}) => {
  return Promise.resolve(api.post(`/admin/exam/harness/validar-importacao/${examId}`, payload));
};

export const getHarnessValidarImportacaoLatest = (examId) => {
  return Promise.resolve(api.get(`/admin/exam/harness/validar-importacao/runs/latest/${examId}`));
};

export const getProva = (id) => {
  return Promise.resolve(api.get("/admin/exam/" + id));
};

export const excluirProva = (id) => {
  return Promise.resolve(api.delete("/admin/exam/" + id));
};

export const getMapas = (data) => {
  return Promise.resolve(api.get("/admin/question-map?" + serialize(data)));
};

export const excluirMapa = (id) => {
  return Promise.resolve(api.delete("/admin/mapa/" + id));
};

export const getQuestoes = (data) => {
  return Promise.resolve(api.get("/admin/question?" + serialize(data)));
};
export const getQuestoesReportadas = (data) => {
  return Promise.resolve(api.get("/admin/question/report-queue?" + serialize(data)));
};

export const getComentariosReportados = (data) => {
  return Promise.resolve(api.get("/admin/comment-report/?" + serialize(data)));
};

export const getDenuncias = (id) => {
  return Promise.resolve(api.get("/admin/question-report/" + id));
};

export const postResolverProblema = (data) => {
  return Promise.resolve(api.post("/admin/question/solve-problem", data));
};

export const postHarnessResolverDenunciaGabarito = (questionId, payload = {}) => {
  return Promise.resolve(
    api.post(`/admin/question/${questionId}/harness/resolver-denuncia-gabarito`, payload)
  );
};

export const getHarnessResolverDenunciaGabaritoLatest = (questionId) => {
  return Promise.resolve(
    api.get(`/admin/question/${questionId}/harness/resolver-denuncia-gabarito/runs/latest`)
  );
};

export const getHarnessResolverDenunciaGabaritoEvents = (questionId, runId, afterId = 0) => {
  return Promise.resolve(
    api.get(
      `/admin/question/${questionId}/harness/resolver-denuncia-gabarito/runs/${runId}/events?after_id=${afterId}`
    )
  );
};

export const postHarnessResolverDenunciaGabaritoAccept = (questionId, runId) => {
  return Promise.resolve(
    api.post(`/admin/question/${questionId}/harness/resolver-denuncia-gabarito/runs/${runId}/accept`)
  );
};

export const postHarnessResolverDenunciaGabaritoDismiss = (questionId, runId) => {
  return Promise.resolve(
    api.post(`/admin/question/${questionId}/harness/resolver-denuncia-gabarito/runs/${runId}/dismiss`)
  );
};

export const updateQuestaoProva = (data) => {
  return Promise.resolve(api.post("/admin/question/update", data));
};

export const updateGabaritoProva = (data) => {
  return Promise.resolve(api.post("/admin/question/update-answer-key", data));
};

export const storeProvaQuestoes = (data, idProva, ultimoNumeroDaQuestao) => {
  return Promise.resolve(api.post("/admin/exam/create-questions", data, idProva, ultimoNumeroDaQuestao));
};

export const getQuestoesByCargo = (data) => {
  return Promise.resolve(api.get("/admin/question/to-import?" + serialize(data)));
};

export const excluirArquivo = (id) => {
  return Promise.resolve(api.delete("/admin/exam/file/" + id));
};

export const salvarArquivo = (data, progress) => {
  return Promise.resolve(api.post("/admin/exam/file", data, progress));
};

export const getMapa = (id) => {
  return Promise.resolve(api.get("/admin/question-map/" + id));
};

export const getUltimaProvaId = (id) => {
  return Promise.resolve(api.get("/admin/prova/ultima-prova/" + id));
};

export const storeMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map", data));
};
export const updateMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/update", data));
};

export const putMapa = (data) => {
  return Promise.resolve(api.put("/admin/mapa", data));
};

export const filtroLotes = (data) => {
  return Promise.resolve(api.get("/admin/batch?" + serialize(data)));
};

export const getLote = (id) => {
  return Promise.resolve(api.get("/admin/batch/" + id));
};

export const excluirLote = (id) => {
  return Promise.resolve(api.delete("/admin/batch/" + id));
};

export const postRejeitarLote = (data) => {
  return Promise.resolve(api.post("/admin/batch/reject", data));
};

export const getBatchExams = data => {
  return Promise.resolve(api.get("/admin/batch/exam?" + serialize(data)));
}

export const getQuestaoPorId = (id) => {
  return Promise.resolve(api.get("/admin/question/" + id));
}

export const getQuestaoTecPorId = (id) => {
  return Promise.resolve(api.get("/admin/tec-question/" + id));
}

export const getLoteQuestaoId = (data) => {
  return Promise.resolve(api.get("/admin/batch/question/add?" + serialize(data)));
};

export const reloadQuestao = (id) => {
  return Promise.resolve(api.put("/admin/question/reload/" + id));
}

export const getAssuntos = (data) => {
  return Promise.resolve(api.get("/admin/batch/matter?" + serialize(data)));
};
export const getMaterias = (data) => {
  return Promise.resolve(api.get("/admin/matter/parent-matters?" + serialize(data)));
};

export const getBancasDeMateriaClassificacao = (data) => {
  return Promise.resolve(api.get("/admin/batch/exam/examining-boards?" + serialize(data)));
};

export const getInstituicaoDeMateriaClassificacao = (data) => {
  return Promise.resolve(api.get("/admin/batch/exam/institutions?" + serialize(data)));
};

export const getAssuntosDeMateriaClassificacao = (data) => {
  return Promise.resolve(api.get("/admin/batch/exam/child-matters?" + serialize(data)));
};

export const postCadastrarLote = (data) => {
  return Promise.resolve(api.post("/admin/batch", data));
};

export const requestIaComment = (id) => {
  return Promise.resolve(api.put("/admin/batch/request-ia-comment/" + id));
};

export const postReprocessarQuestaoIALote = (data) => {
  return Promise.resolve(api.post("/admin/question/reprocess-ia-comment/", data));
};

export const getIaCommentPrompts = (params) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts?" + serialize(params)));
};

export const getIaCommentPromptMatterOptions = (params = {}) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/matter-options?" + serialize(params)));
};

export const getIaCommentPromptMatterFilterOptions = (params = {}) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/matter-filter-options?" + serialize(params)));
};

export const getIaCommentPrompt = (matterId) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId));
};

export const createIaCommentPrompt = (data) => {
  return Promise.resolve(api.post("/admin/ia-comment-prompts", data));
};

export const updateIaCommentPrompt = (matterId, data) => {
  return Promise.resolve(api.put("/admin/ia-comment-prompts/" + matterId, data));
};

export const uploadIaCommentPromptAttachments = (matterId, files, matterIds) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files[]', file));
  matterIds.forEach((id) => formData.append('matter_ids[]', id));

  return Promise.resolve(api.post("/admin/ia-comment-prompts/" + matterId + "/attachments", formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  }));
};

export const updateIaCommentPromptAttachmentMatters = (matterId, attachmentId, matterIds) => {
  return Promise.resolve(api.put(
    "/admin/ia-comment-prompts/" + matterId + "/attachments/" + attachmentId,
    {matter_ids: matterIds},
  ));
};

export const getIaCommentPromptSubjectOptions = (matterId) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/subject-options"));
};

export const deleteIaCommentPromptAttachment = (matterId, attachmentId) => {
  return Promise.resolve(api.delete("/admin/ia-comment-prompts/" + matterId + "/attachments/" + attachmentId));
};

export const getIaCommentPromptAttachment = (matterId, attachmentId) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/attachments/" + attachmentId, {
    responseType: 'blob',
  }));
};

export const testIaCommentPrompt = (data) => {
  return Promise.resolve(api.post("/admin/ia-comment-prompts/test", data));
};

export const getIaCommentPromptVersions = (matterId) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/versions"));
};

export const getIaCommentPromptVersion = (matterId, version) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/versions/" + version));
};

export const getIaCommentPromptGenerations = (matterId, params) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/generations?" + serialize(params)));
};

export const getIaCommentPromptGeneration = (matterId, gptCommentId) => {
  return Promise.resolve(api.get("/admin/ia-comment-prompts/" + matterId + "/generations/" + gptCommentId));
};

export const getIaCostConfig = () => {
  return Promise.resolve(api.get("/admin/ia-costs/config"));
};

export const getIaCostSummary = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/summary?" + serialize(params)));
};

export const getExecutiveDashboard = (params) => {
  return Promise.resolve(api.get("/admin/dashboard?" + serialize(params)));
};

export const getExecutiveDashboardSummary = (params) => {
  return Promise.resolve(api.get("/admin/dashboard/summary?" + serialize(params)));
};

export const getExecutiveDashboardEngagement = (params) => {
  return Promise.resolve(api.get("/admin/dashboard/engagement?" + serialize(params)));
};

export const getExecutiveDashboardQuestionBank = () => {
  return Promise.resolve(api.get("/admin/dashboard/question-bank"));
};

export const getExecutiveDashboardBacklog = () => {
  return Promise.resolve(api.get("/admin/dashboard/backlog"));
};

export const getExecutiveDashboardOperations = () => {
  return Promise.resolve(api.get("/admin/dashboard/operations"));
};

export const getExecutiveDashboardFinancial = () => {
  return Promise.resolve(api.get("/admin/dashboard/financial"));
};

export const getIaCostDailySeries = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/daily-series?" + serialize(params)));
};

export const getIaCostByMatter = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/by-matter?" + serialize(params)));
};

export const getIaCostMatters = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/matters?" + serialize(params)));
};

export const getIaCostByModel = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/by-model?" + serialize(params)));
};

export const getIaCostByBatch = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/by-batch?" + serialize(params)));
};

export const getIaCostByOrigin = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/by-origin?" + serialize(params)));
};

export const getIaCostGenerations = (params) => {
  return Promise.resolve(api.get("/admin/ia-costs/generations?" + serialize(params)));
};

export const generateIaComment = (data) => {
  return Promise.resolve(api.post("/admin/question/generate-ia-comment", data, {
    timeout: 180000,
  }));
};

export const getUsuarioPlano = (id) => {
  return Promise.resolve(api.get("/admin/user/plan/" + id));
};

export const cancelarUsuarioPlano = (data) => {
  return Promise.resolve(api.post("/admin/user/cancel-plan", data));
};

export const caonfirmarPagamentoPlano = (data) => {
  return Promise.resolve(api.post("/admin/user/confirm-payment-plan", data));
};

export const alterarProfessor = (data) => {
  return Promise.resolve(api.post("/admin/batch/change-teacher", data));
};

export const enviarEmailNotificacao = (data) => {
  return Promise.resolve(api.post("/admin/batch/send-teacher-email", data));
};
// #### END-POINTS PROFESSOR ####

export const getQuestoesLote = (id) => {
  return Promise.resolve(api.get("/admin/batch/questions/" + id));
};

export const getHistoricoQuestoes = (id) => {
  return Promise.resolve(api.get("/admin/question/history/" + id));
};

export const getArquivosPdf = (id) => {
  return Promise.resolve(api.get("/admin/pdf/questoes/" + id));
};

export const postClassificarQuestao = (data) => {
  return Promise.resolve(api.post("/admin/question/classify", data));
};

export const postComentarQuestao = (data) => {
  return Promise.resolve(api.post("/admin/question/comment", data));
};


export const storeAssuntoSugerido = (data) => {
  return Promise.resolve(api.post("/admin/assunto/lote/classificacao/sugerir", data));
};

export const deleteMatterAndRelocateQuestions = (data) => {
  return Promise.resolve(api.post("/admin/matter/delete-and-relocate-questions", data));
};

export const postMoverAssuntoSugerido = (data) => {
  return Promise.resolve(api.post("/admin/assunto/lote/classificacao/mover", data));
};

export const getAssuntosSugeridos = (id) => {
  return Promise.resolve(api.get("/admin/batch/matter/suggested/" + id));
};

export const postRelatarProblema = (data) => {
  return Promise.resolve(api.post("/admin/question-report", data));
};

export const getRelatorioVendas = (data) => {
  return Promise.resolve(api.get("/admin/payment?" + serialize(data)));
};

export const getRelatorioRecorrencias = (data) => {
  return Promise.resolve(api.get("/admin/signature?" + serialize(data)));
};

export const getComentario = (id) => {
  return Promise.resolve(api.get("/admin/comment/report/" + id));
};

export const excluirComentario = (data) => {
  return Promise.resolve(api.delete("/admin/comment?" + serialize(data)));
};
export const getQuestoesCentralComentarios = (data) => {
  return Promise.resolve(api.get("/admin/comment/notification-center?" + serialize(data)));
};
export const getCursos = () => {
  return Promise.resolve(api.get("/admin/questoes-filtro-curso"));
};

export const getCadernos = (id) => {
  return Promise.resolve(api.get("/admin/questoes-filtro-caderno/" + id));
};

export const getComentariosByQuestao = (data) => {
  return Promise.resolve(api.get("/admin/comment/by-question?" + serialize(data)));
};
export const validarComentario = (data) => {
  return Promise.resolve(api.post("/admin/comment/validate", data));
};

export const getQuestoesComentarioSolicitado = (data) => {
  return Promise.resolve(api.get("/admin/question-comment-request?" + serialize(data)));
};

export const getEmailsComentarioSolicitado = (id) => {
  return Promise.resolve(api.get("/admin/question-comment-request/emails/" + id));
};

export const getQuestoesPorMateria = (data) => {
  return Promise.resolve(api.get("/admin/matter/questions-per-matter?" + serialize(data)));
};
export const getProfessor = (id) => {
  return Promise.resolve(api.get("/admin/user/teacher/" + id));
};
export const storeProfessor = (data) => {
  return Promise.resolve(api.post("/admin/user/teacher", data));
};

export const excluirComentarioQuestao = (data) => {
  return Promise.resolve(api.post("/admin/question/delete-comment", data));
};

export const excluirClassificacaoQuestao = (id) => {
  return Promise.resolve(api.put("/admin/question/remove-classification/" + id));
};
export const desvincularLotesQuestao = (id) => {
  return Promise.resolve(api.put("/admin/question/unlink-batches/" + id));
};
export const postSalvarStringAssunto = (data) => {
  return Promise.resolve(api.post("/admin/matter/store-search-string", data));
};
export const getAssunto = (id) => {
  return Promise.resolve(api.get("/admin/matter/" + id));
};
export const getReviewsMapas = (data) => {
  return Promise.resolve(api.get("/admin/mapa-reviews?" + serialize(data)));
};

export const getAssuntosMapa = (id) => {
  return Promise.resolve(api.get("/admin/question-map/matters/" + id));
};

export const postNovoAssuntoMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/matters", data));
};

export const getAssuntosFilhosMapa = (id) => {
  return Promise.resolve(api.get("/admin/question-map/matters/" + id + "/children"));
};

export const editAssuntoMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/update-matter", data));
};
export const deleteAssuntoMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/delete-matter", data));
};

export const reorderAssuntoMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/matters/reorder", data));
};
export const getMapasComProvas = (data) => {
  return Promise.resolve(api.get("/admin/question-map/with-exams?" + serialize(data)));
};
export const importarAssuntosMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/import-matters", data));
};

export const getAllAssuntosMapa = (id) => {
  return Promise.resolve(api.get("/admin/question-map/all-matters/" + id));
}
export const associarAssuntos = (data) => {
  return Promise.resolve(api.post("/admin/question-map/associate-matters", data));
};
export const getHistoricoProva = (id) => {
  return Promise.resolve(api.get("/admin/exam/history/" + id));
};

export const postSalvarProvasMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/exams", data));
};

export const getProvasMapa = (id) => {
  return Promise.resolve(api.get("/admin/exam/by-question-map/" + id));
}

export const getExamFilterOptions = (data) => {
  const filteredData = Object.fromEntries(
    Object.entries(data || {}).filter(([, value]) => {
      if (value === null || value === undefined || value === '') {
        return false
      }
      if (Array.isArray(value) && value.length === 0) {
        return false
      }
      return true
    })
  )

  return Promise.resolve(api.get("/admin/exam/filter-options?" + serializeArray(filteredData)));
}

export const getContagemAssuntos = (id) => {
  return Promise.resolve(api.get("/admin/question-map/matters-count/" + id));
}

export const atualizarContagemQuestoesMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/update-question-count", data));
};

export const salvarLimitesDisciplinaMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/discipline-limits", data));
};

export const copiarProvasMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/merge", data));
};

export const storeAssuntosEdital = (data) => {
  return Promise.resolve(api.post("/admin/question-map/update-notice", data));
}

export const verticalizeAssuntosEditalIa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/verticalize-notice-ai", data));
}

export const clonarMapa = (data) => {
  return Promise.resolve(api.post("/admin/question-map/clone", data));
};

export const salvarGabaritoProva = (data) => {
  return Promise.resolve(api.post("/admin/exam/store-answer-key-type", data));
};

export const getAssuntoDesatualizacao = (id) => {
  return Promise.resolve(api.get("/admin/matter/outdated/" + id));
};

export const desatualizarAssunto = (data) => {
  return Promise.resolve(api.post("/admin/matter/mark-questions-as-outdated", data));
};

export const updateDeadLineLote = (data) => {
  return Promise.resolve(api.post("/admin/batch/update-expected-date", data));
};

export const getPlanos = () => {
  return Promise.resolve(api.get("/admin/plan?"));
};

export const incidenciaProvas = data => {
  return Promise.resolve(api.get("/admin/prova-incidencia?" + serialize(data)));
}

export const getAllAssuntosFilhos = (data) => {
  return Promise.resolve(api.get("/admin/assunto-filhos?" + serialize(data)));
};

export const associarAssuntosCursoteca = (data) => {
  return Promise.resolve(api.post("/admin/assunto-cursoteca/associar", data));
};

export const getCadernosCurso = (data) => {
  return Promise.resolve(api.get("/admin/cadernos-curso?" + serialize(data)));
};

export const getProvasDuplicadas = (data) => {
  return Promise.resolve(api.get("/admin/provas-duplicadas?" + serialize(data)));
};

export const migrarQuestoesProva = (data) => {
  return Promise.resolve(api.post("/admin/provas/migrar-questoes-duplicadas", data));
};

export const migrarComentario = (data) => {
  return Promise.resolve(api.post("/admin/comment/migrate", data));
};

export const getFilhosIncidencia = data => {
  return Promise.resolve(api.get("/admin/prova/filhos/incidencia?" + serialize(data)));
}

export const getHistoricoLog = data => {
  return Promise.resolve(api.get("/admin/entity-event?" + serialize(data)));
};

export const getAssuntosEL = data => {
  return Promise.resolve(api.get("/admin/matter?" + serialize(data)));
  // let cacheKey = '/admin/matter?' + serialize(data);
  // return get(cacheKey);
}

export const getSimulados = (data) => {
  return Promise.resolve(api.get("/admin/simulated?" + serialize(data)));
};

export const getSimulado = (id) => {
  return Promise.resolve(api.get("/admin/simulated/" + id));
};

export const getQuestoesSelecionadas = (id) => {
  return Promise.resolve(api.get("/admin/simulated/module/questions/" + id));
};

export const storeSimulado = (data) => {
  return Promise.resolve(api.post("/admin/simulated", data));
};

export const storeSimuladoQuestoes = (data) => {
  return Promise.resolve(api.post("/admin/simulated/module/questions", data));
};

export const deleteSimulado = (id) => {
  return Promise.resolve(api.delete("/admin/simulated/" + id));
};
export const deleteModule = (id) => {
  return Promise.resolve(api.delete("/admin/caderno-simulado/modulo" + id));
};

export const storeMatter = (data) => {
  return Promise.resolve(api.post("/admin/matter", data));
};

export const batchUpdateMatters = (data) => {
  return Promise.resolve(api.post("/admin/matter/batch-update", data));
};

export const deleteMatter = (data) => {
  return Promise.resolve(api.post("/admin/matter/delete", data));
};

export const relocateMatter = (data) => {
  return Promise.resolve(api.post("/admin/matter/relocate", data));
};

// Copiar ramo da Árvore TEC para o Mapa Atual
export const copyTecBranchToMap = (data) => {
  return Promise.resolve(api.post("/admin/question-bank/matters/copy", data));
};

export const confirmBatchPayment = (data) => {
  return Promise.resolve(api.post("/admin/batch/confirm-payment", data));
};

export const enableBatch = id => {
  return Promise.resolve(api.put("/admin/batch/enable/" + id));
};

export const finishBatch = (data) => {
  return Promise.resolve(api.post("/admin/batch/finish", data));
};

export const finishClassificationOrComment = id => {
  return Promise.resolve(api.put("/admin/batch/finish-classification-comment/" + id));
};

export const approveMatter = id => {
  return Promise.resolve(api.put("/admin/batch/matter/approve/" + id));
};

export const finishExamValidation = (data) => {
  return Promise.resolve(api.post("/admin/exam/finish-validation", data));
};

export const finishExamReview = (id) => {
  return Promise.resolve(api.put("/admin/exam/finish-review/" + id));
};

export const updateUserPlan = (data) => {
  return Promise.resolve(api.post("/admin/user/update-plan", data));
};

export const getQuestoesFiltradas = data => {
  let cacheKey = '/question';
  return get(cacheKey, data);
}

export const getCountQuestoes = data => {
  let cacheKey = '/question/count';
  return get(cacheKey, data);
}

export const getIncidencia = data => {
  let cacheKey = '/question/incidence';
  return get(cacheKey, data);
}

export const getAssuntosApi = data => {
  let cacheKey = '/matter';
  return get(cacheKey, data);
}

export const get = async (url, data) => {
  const queryString = serializeArray(data);
  let cacheKey = url + '?' + queryString;
  let response = sessionStorage.getItem(cacheKey);
  if (response) {
    return Promise.resolve(JSON.parse(response));
  } else {
    return Promise.resolve(api.get(url + "?" + queryString))
      .then(result => {
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify(result));
        } catch (e) {
          console.error(e)
        }
        return Promise.resolve(result);
      }).catch(e => console.log(e));
  }
}

export const limparSessionStorage = () => {
  sessionStorage.clear();

  return true;
}

export const storeImportedQuestions = (data) => {
  return Promise.resolve(api.post("/admin/question/import", data));
};

export const postResponderQuestao = (data) => {
  return Promise.resolve(api.post('/customer-area/question/answer', data));
}

export const updateUser = (data) => {
  return Promise.resolve(api.post('/admin/user/estudante', data));
};

export const getIaClassifications = (params = {}) => {
  return Promise.resolve(api.get('/admin/ia-classifications?' + serialize(params)));
};

export const searchIaClassificationMatterNodes = (q, limit = 25, leaves = false, parentId = null, outdated = false) => {
  return Promise.resolve(api.get('/admin/ia-classifications/matter-nodes?' + serialize({
    q,
    limit,
    leaves: leaves ? 1 : 0,
    ...(parentId ? { parent_id: parentId } : {}),
    ...(outdated ? { outdated: 1 } : {}),
  })));
};

export const approveIaClassification = (id, outdated = null, reviewerNote = null) => {
  return Promise.resolve(api.post(`/admin/ia-classifications/${id}/approve`, {
    ...(outdated === null ? {} : {outdated: outdated ? 1 : 0}),
    ...(reviewerNote == null || reviewerNote === '' ? {} : {reviewer_note: reviewerNote}),
  }));
};

export const rejectIaClassification = (id, reviewerNote = null) => {
  return Promise.resolve(api.post(`/admin/ia-classifications/${id}/reject`, {
    ...(reviewerNote == null || reviewerNote === '' ? {} : {reviewer_note: reviewerNote}),
  }));
};

export const adjustIaClassification = (id, leafMatterIds, outdated = null, reviewerNote = null) => {
  return Promise.resolve(api.post(`/admin/ia-classifications/${id}/adjust`, {
    leaf_matter_ids: leafMatterIds,
    ...(outdated === null ? {} : {outdated: outdated ? 1 : 0}),
    ...(reviewerNote == null || reviewerNote === '' ? {} : {reviewer_note: reviewerNote}),
  }));
};

export const getIaClassificationFeedback = (params = {}) => {
  return Promise.resolve(api.get('/admin/ia-classifications/feedback?' + serialize(params)));
};

export const updateIaClassificationFeedback = (id, payload = {}) => {
  return Promise.resolve(api.patch(`/admin/ia-classifications/${id}/feedback`, payload));
};

export const createSuggestedIaMatter = (id, name, parentMatterId, outdated = null) => {
  return Promise.resolve(api.post(`/admin/ia-classifications/${id}/create-suggested-matter`, {
    name,
    parent_matter_id: parentMatterId,
    ...(outdated === null ? {} : {outdated: outdated ? 1 : 0}),
  }));
};

